import tv4 from "tv4";

tv4.addFormat("phone", (value: string) => {
	if(value === undefined || value === null || value === "") {
		return null;
	}

	return /^\(?(\d{3})\)?[-.\s]?(\d{3})[-.\s]?(\d{4})$/.test(value)
        ? null
        : "Enter a valid phone number.";
});